import { useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export interface FilterOption {
  id: number;
  name: string;
}

/**
 * Lightweight, active-only project options for filter dropdowns.
 * Backed by GET /api/filter/projects — unlike useProjects()/`/api/project/all`,
 * it never returns deleted/inactive projects and carries no nested data.
 */
export const useFilterProjects = () => {
  const [projects, setProjects] = useState<FilterOption[]>([]);
  const httpClient = useHttpClient();

  useEffect(() => {
    const fetchFilterProjects = async () => {
      const response = await httpClient.current?.get('/api/filter/projects');
      const data = response?.data || [];
      setProjects(data.map((p: { id: number; label: string }) => ({ id: p.id, name: p.label })));
    };
    fetchFilterProjects();
  }, [httpClient]);

  return { projects };
};
